<template>
  <div class="mask" @click.self="clickPopup('cancel')">
    <div class="popup" id="popWindow">
      <h1 :class="{ hmt: callbackpath === 'touristhmtplaceorder'}">{{ title }}</h1>
      <div class="text">{{ content }}</div>
      <div class="choice">
        <div @click="clickPopup('cancel')">{{ cancelName }}</div>
        <div @click="clickPopup('determine')">{{confirmName}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "selectpopup",
  props: ["title", "content", "callbackpath"],
  computed: {
    cancelName() {
      if(this.callbackpath === 'touristhmtplaceorder') {
        return '取消 Cancel'
      }else if(this.callbackpath === 'touristhmtplaceorderEn') {
        return 'Cancel'
      }else {
        return '取消'
      }
    },
    confirmName() {
      if(this.callbackpath === 'touristhmtplaceorder') {
        return '确定 Confirm'
      }else if(this.callbackpath === 'touristhmtplaceorderEn') {
        return 'Confirm'
      }else {
        return '确定'
      }
    }
  },
  mounted() {
    // 切记  一定要在组件里加
    this.$nextTick(() => {
      const body = document.querySelector("body");
      if (body.append) {
        body.append(this.$el);
      } else {
        body.appendChild(this.$el);
      }
      this.$store.commit("setWindowMaskEl", this.$el);
    });
  },
  methods: {
    clickPopup(state) {
      this.$emit("onselectpopup", state);
    }
  }
};
</script>

<style scoped lang="less">
.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  // height: 100vh;
  width: 100%;
  background: rgba(0, 0, 0, 0.46);
  .popup {
    width: 4.666667rem * 2;
    min-height: 4.48rem;
    background: #ffffff;
    border-radius: 0.08rem * 2;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    padding: 0.266667rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    h1 {
      font-size: 0.24rem * 2;
      color: #222328;
      line-height: 0.666667rem;
      font-weight: bold;
    }
    .hmt {
      white-space: pre-wrap;
      line-height: 0.666667rem !important;
    }
    .text {
      line-height: 0.586667rem;
      font-size: 0.213333rem * 2;
    }
    .choice {
      display: flex;
      justify-content: space-between;
      div {
        width: 2.106667rem * 2;
        line-height: 0.586667rem * 2;
        border-radius: 0.16rem;
        color: #ffffff;
        font-weight: bold;
        font-size: 0.533333rem;
        &:first-child {
          background: #a1a6ba;
        }
        &:last-child {
          background: #3b6d9c;
        }
      }
    }
  }
}
</style>
